import React from 'react';

interface Props {
    onClose: () => void;
    heading: string;
    decription: string
}

const SuccessCreate: React.FC<Props> = ({ heading, onClose, decription }) => {
    return (
        <div className="lc-modal-overlay">
            <div className="lc-modal">
                <button className="lc-modal__close" onClick={onClose}>
                    <img src='/assets/images/dismiss.svg' alt='close' />
                </button>

                {/* Badge icon */}
                <div className="lc-modal__icon">
                    <img src='/assets/images/badge-check.svg' alt='location created' />
                </div>

                <h2 className="lc-modal__title">{heading || ''}</h2>
                <p className="lc-modal__desc">{decription || ''}</p>
            </div>
        </div>
    );
};

export default SuccessCreate;